/**
 * Editorial journal manifest.
 *
 * Each post is a metadata record plus a body component. The body
 * components are plain JSX so authors can use platform components
 * (LuxuryCard, GoldDivider, WaxSeal, Indicium, photos) and tailwind
 * tokens without leaving the codebase. No MDX toolchain needed.
 *
 * Adding a new post:
 *   1. Create `<slug>.jsx` in this folder, default-export a component.
 *   2. Add a metadata entry to POSTS below.
 *
 * The metadata record drives the index listing, social meta tags,
 * and the post-detail header rendering.
 */
import HowWeVerifyAKennel from "./how-we-verify-a-kennel";
import TheArmstrongK9Standard from "./the-armstrong-k9-standard";
import WhatASixGenerationPedigreeProves from "./what-a-six-generation-pedigree-proves";
import WhatAVerifiedKennelEarns from "./what-a-verified-kennel-earns";

export const POSTS = [
  {
    slug: "what-a-verified-kennel-earns",
    title: "What a verified kennel earns",
    dek: "The Verified tier in writing — the WaxSeal, search priority, downloadable badge, waitlist deposits, and the video-tour revenue split. No marketing fog.",
    section: "For breeders",
    readMinutes: 6,
    publishedAt: "2026-02-10",
    Body: WhatAVerifiedKennelEarns,
  },
  {
    slug: "how-we-verify-a-kennel",
    title: "How we verify a kennel",
    dek: "The seven checks behind every gold WaxSeal — and why we walk away from kennels that won't pass them.",
    section: "Trust & safety",
    readMinutes: 6,
    publishedAt: "2026-02-09",
    Body: HowWeVerifyAKennel,
  },
  {
    slug: "the-armstrong-k9-standard",
    title: "The Armstrong K9 standard",
    dek: "We don't tell breeders how to breed. We tell buyers what 'verified' means here, in writing, with no asterisks.",
    section: "Editorial",
    readMinutes: 5,
    publishedAt: "2026-02-09",
    Body: TheArmstrongK9Standard,
  },
  {
    slug: "what-a-six-generation-pedigree-proves",
    title: "What a 6-generation pedigree actually proves",
    dek: "Pedigree depth isn't bragging — it's the only reliable way to surface inbreeding risk before a litter is on the ground.",
    section: "Pedigrees",
    readMinutes: 7,
    publishedAt: "2026-02-09",
    Body: WhatASixGenerationPedigreeProves,
  },
];

export const findPost = (slug) => POSTS.find((p) => p.slug === slug) || null;
